import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { EventTypesActions, WorldActions } from "../_actions";
import { useModal } from "../_contexts";
import { Modal } from "../_components";
import { NewEventForm } from "./forms";

export function NewEvent(props) {
  // console.log('modal params', props);
  const dispatch = useDispatch();
  const { items: eventTypes } = useSelector((state) => state.eventTypes);
  const { subgroups } = useSelector((state) => state.world);
  const { closeModal } = useModal();

  const { timeline, eventItem, prevModal } = props;

  const allowedTypes = eventTypes
    ? eventTypes.sort((a, b) => (a.name < b.name ? -1 : 1))
    : [];

  useEffect(() => {
    if (!eventTypes) {
      dispatch(EventTypesActions.getGlobalEventTypes());
    }
    if (!subgroups) {
      dispatch(
        WorldActions.getSubGroups("ccc3ba45-4a16-4726-a495-60c9c83f8777")
      );
    }
  }, [subgroups]);

  return (
    <Modal
      id="newEventModal"
      // backdrop
      title={eventItem?._id ? "Edit Event" : "New Event"}
      icon="fas fa-sparkles fa-fw"
      size="md"
      open={true}
      onClose={() => closeModal()}
    >
      <NewEventForm
        timeline={timeline}
        allowedTypes={allowedTypes}
        subgroups={subgroups}
        item={eventItem}
        close={closeModal}
        prevModal={prevModal}
      />
    </Modal>
  );
}
